



































































































































import Component from 'vue-class-component';
import PluginComponent from '../PluginComponent';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { extend } from 'ol/extent';
import { fromExtent } from 'ol/geom/Polygon';
import { Feature } from 'ol';
import StyleRule from '@/models/map-context/style/StyleRule';
import { get } from 'ol/proj';

Chart.plugins.register(ChartDataLabels);

@Component({
  props: {},
  components: {},
})
export default class ChartsPlugin extends PluginComponent {
  static ID = 'ChartsPlugin';

  selectedVolType = '';

  selectedCompany = '';

  selectedIdPlot="";

  selectedRefMateriel = '';

  selectedMarque = '';

  selectedNumSerie :any = null;

  searchNumSerie= '';

  isLoading = false;

  startDate: string | null = null;
  
  endDate: string | null = null;

  productTypes = [
    { value: '', text: 'Sélectionner une condition vol' },
  ];

  municipalities = [
    { value: '', text: 'Sélectionner une commune' },
  ];

  refMateriels = [
    { value: '', text: 'Sélectionner un matériel' },
  ];

  autocompleteNumSerie: { label: string; value: string }[] = [];

  marques = [
    { value: '', text: 'Sélectionner une marque' },
  ];

  companies = [
    { value: '', text: 'Sélectionner une entreprises' },
  ];

  filteredData: any[] = [];

  condition_vol: any[] = [];

  labels: any[] = [];

  values: any[] = [];

  chartInstances: Chart[] = [];
  
  selectedFeature= false;

  datas=[];

  harvestedDatas=[];

  showFilters=true;

  showCharts= true;

  unitPrice=-1;

  priceInfoUnit="";

  listStyle: StyleRule[] = [];

  area=0;

  created(){
    this.fetchDatas();
    // this.resetSearch()
  }

  resetSearch(){
    this.startDate = null;
    this.endDate = null;
    this.selectedVolType = '';
    this.selectedRefMateriel = '';
    this.selectedMarque = '';
    this.selectedNumSerie = null;
    this.updateCharts();
  }


  mounted() {
    // EventBus.$on(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    // EventBus.$on(EVENTS.SELECT_NO_FEATURE, this.cleanSelection);
    
    // if(!this.selectedFeature){
    //   this.filteredData = [];
    //   //this.updateCharts();
    // }

    // const selectedFeatures = this.getMapService().selectionService.selectedFeature;
    // if (selectedFeatures !== undefined) {
    //   // this.onFeatureSelected(selectedFeatures);
    // }
    // this.resetSearch()
    this.listStyle = this.getMapService()?.getLayersByLayerName("neogeo:v_vol_topo_1")?.complexStyle?.styleRules ?? [] 
  }
  getDistinctValues(list:any):any[] {
    const distinct=list.filter((item:any, i:any, ar:any) => ar.indexOf(item) === i);
    return distinct;
  }
  closePanel(){
    this.getMapService().selectionService.cleanSelection();
    this.getMapService().selectionService.selectFeatures([],false,false);
  }

  // getBaseUrl() {
  //   let url = window.location.href;
  
  //   if (url.startsWith("https://rec.")) {
  //     url = url.replace("https://rec.", "https://admin.rec.");
  //   }
  
  //   return url.split("/maps")[0];
  // }

  async fetchDatas() {
    // let url = this.getBaseUrl();
    // let url = "https://admin.fenigs.neogeo.fr";
    // let url = "https://admin.rec.protec-topo.neogeo.fr";
	  let url = window.location.href.split("/maps")[0];
    const urlVol = `${url}/geoserver/neogeo/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=neogeo:v_vol_topo_1&outputFormat=json`;

    try {
      this.isLoading = true;
      const responseVol = await fetch(urlVol);
      const dataJson = await responseVol.json();
      
      const dataFeature = dataJson.features;
      
      const layerSource = this.getMapService().getLayersByLayerName("neogeo:v_vol_topo_1")?.getLayerSource();


      let companies = this.getDistinctValues(dataFeature.map((x: any) => x.properties.entreprise));
      companies.forEach((companyName: any) => {
        this.companies.push({ value: companyName, text: companyName });
      });
      this.condition_vol = this.getDistinctValues(dataFeature.map((x: any) => x.properties.condition_vol))
        .filter((val: any) => val && val.trim() !== '')  
        .sort();
      this.condition_vol.forEach((condition_vol: any) => {
        this.productTypes.push({ value: condition_vol, text: condition_vol });
      });

      this.municipalities = this.getDistinctValues(dataFeature.map((x: any) => x.properties.commune_vol));
      this.municipalities.forEach((commune: any) => {
          this.municipalities.push({ value: commune, text: commune });
      });

      const refMaterielList = this.getDistinctValues(
          dataFeature.map((x: any) => x.properties.ref_materiel)
      )
          .filter((val: any) => val && val.trim() !== '')
          .sort((a: string, b: string) => {
              const A = a.trim().toLowerCase();
              const B = b.trim().toLowerCase();

              if (A === 'autre') return 1;
              if (B === 'autre') return -1;
              return A.localeCompare(B);
          });

      refMaterielList.forEach((ref: any) => {
          this.refMateriels.push({ value: ref, text: ref });
      });

      const marqueList = this.getDistinctValues(dataFeature.map((x: any) => x.properties.marque))
        .filter((val: any) => val && val.trim() !== '' && val.trim() !== '-')  
        .sort();
      marqueList.forEach((m: any) => {
        this.marques.push({ value: m, text: m });
      });

      // this.autocompleteNumSerie = this.getDistinctValues(dataFeature.map((x: any) => x.properties.num_serie));
      this.autocompleteNumSerie = this.getDistinctValues(
        dataFeature.map((x: any) => x.properties.num_serie)
      )
        .filter((num: any) => num && num.trim() !== '')
        .sort()
        .map(num => ({
          label: num,
          value: num
        }))

      console.log("this.autocompleteNumSerie", this.autocompleteNumSerie);

      this.datas = dataFeature;

      if (!layerSource) {
        console.error("La source de la couche est introuvable.");
        return;
      }

      const checkFeaturesLoaded = () => {
        const features = layerSource.getFeatures();
        if (features.length > 0) {
          this.updateCharts();
          this.isLoading = false;
        } else {
          console.warn("Les fonctionnalités ne sont pas encore chargées, réessai...");
          setTimeout(checkFeaturesLoaded, 500);
        }
      };

      checkFeaturesLoaded();
    } catch (error) {
        console.error(`Erreur lors de la récupération des données :`, error);
      this.isLoading = false;
    }
  }


  groupDataByConditionVol(data:any) {
    const groupedDataVol = data.reduce((acc: any, feature: any) => {
      const conditionVol = feature.properties.condition_vol || "Non spécifié";
      if (!acc[conditionVol]) {
        acc[conditionVol] = 0;
      }
      acc[conditionVol] += 1;
      return acc;
    }, {});
    const { keys , values, total} = this.getKeysValuesAndTotal(groupedDataVol)
    const backgroundColor = this.getColorsPoint(keys, this.listStyle)
    this.filteredData.push({
      title: "Nombre de vols par type de vol",
      label: "Nombre",
      total: total,
      unit: "vols",
      keys,
      values,
      backgroundColor
    });
  }

  getColorsPoint(labels: string[], styles: any[]) {
    return labels
        .map(label => styles.find(styleObj => styleObj.label === label))
        .filter(styleObj => styleObj)
        .map(styleObj => styleObj!.style.pointSymbol.getSymbolFillColor());
  }

  groupDataByConditionVolByPrice(data: any) {
    const groupedDataVol = data.reduce((acc: any, feature: any) => {
      const conditionVol = feature.properties.condition_vol || "Non spécifié";
      const valeurAchat = feature.properties.valeur_achat || 0;

      if (!acc[conditionVol]) {
        acc[conditionVol] = 0;
      }
      acc[conditionVol] += valeurAchat;
      return acc;
    }, {});

    const { keys, values, total } = this.getKeysValuesAndTotal(groupedDataVol);
    const backgroundColor = this.getColorsPoint(keys, this.listStyle)

    this.filteredData.push({
      title: "Répartition des valeurs des équipements volés.",
      label: "Prix",
      total: total,
      unit: "Euros",
      keys,
      values,
      backgroundColor,
    });
  }

  groupDataByRegionGroup(data: any) {
    const groupedData = data.reduce((acc: any, feature: any) => {
      const region = feature.properties.region || "Non spécifié";
      if (!acc[region]) {
        acc[region] = 0;
      }
      acc[region] += 1;
      return acc;
    }, {});
    
    const { keys, values, total } = this.getKeysValuesAndTotal(groupedData);
    const backgroundColor = this.getColorsPoint(keys, this.listStyle);
    console.log("groupDataByRegionGroup", data, values, keys, total);
  
    this.filteredData.push({
      title: "Nombre de vols par région",
      total,
      label: "Nombre",
      unit: "vols",
      keys,
      values,
      backgroundColor
    });
  }
  

  groupDataByCommuneVol(data: any) {
    const groupedDataVol = data.reduce((acc: any, feature: any) => {
        const communeVol = feature.properties.region || "Non spécifié";
        if (!acc[communeVol]) {
            acc[communeVol] = 0;
        }
        acc[communeVol] += 1;
        return acc;
    }, {});

    const { keys, values, total } = this.getKeysValuesAndTotal(groupedDataVol);
    const backgroundColor = this.getColorsPoint(keys, this.listStyle);

    this.filteredData.push({
        title: "Nombre de vols par region",
        total: total,
        label: "Nombre",
        unit: "vols",
        keys,
        values,
        backgroundColor
    });
  }


  groupAndCountByViolence(data: any) {
    const dataViolence =  data.reduce(
      (acc: any, feature: any) => {
        const isViolent = feature.properties.vol_violence === "Oui" ? "Violent" : "Non violent";
        if (!acc[isViolent]) {
          acc[isViolent] = 0;
        }
        acc[isViolent] += 1;
        return acc;
      },
      { Violent: 0, "Non violent": 0 } // Initialisation
    );
    const { keys , values, total} = this.getKeysValuesAndTotal(dataViolence)
    const backgroundColor = this.getColorsPoint(keys, this.listStyle)
    this.filteredData.push({
      title: "Violence Vol",
      total: total,
      unit: "vols",
      keys,
      values,
      backgroundColor,
    });
  }

  groupDataByRefMaterielVol(data: any) {
    const groupedData = data.reduce((acc: any, feature: any) => {
      const refMateriel = feature.properties.ref_materiel || "Non spécifié";
      if (!acc[refMateriel]) {
        acc[refMateriel] = 0;
      }
      acc[refMateriel] += 1;
      return acc;
    }, {});

    const { keys, values, total } = this.getKeysValuesAndTotal(groupedData);
    const backgroundColor = this.getColorsPoint(keys, this.listStyle);

    this.filteredData.push({
      title: "Matériel ciblé",
      label: "Nombre",
      total: total,
      unit: "vols",
      keys,
      values,
      backgroundColor
    });
  }

  computeChartDataByCondition(data:any) {
    this.groupDataByConditionVol(data);
    // this.groupDataByCommuneVol(data);
    this.groupDataByRefMaterielVol(data);
    this.groupDataByRegionGroup(data);
  }

  getKeysValuesAndTotal(dataObject:any) {
    const keys = Object.keys(dataObject); 
    const values = Object.values(dataObject); 
    const total = values.reduce((sum : any, value: any) => sum + value, 0);

    return { keys, values, total };
  }

  beforeDestroy() {
    this.chartInstances.forEach(chart => chart.destroy());
  }

  // cleanSelection(){
  //   this.showFilters=true;
  //   this.selectedFeature=false;
  //   this.updateCharts();
  // }
  
  async updateCharts() {
    this.filteredData = [];

    let filtered = this.filterDatas();
    let layerSource=this.getMapService().getLayersByLayerName("neogeo:v_vol_topo_1")?.getLayerSource();
    if (this.startDate && this.endDate) {
      const start = new Date(this.startDate).getTime();
      const end = new Date(this.endDate).getTime();
      
      filtered = filtered.filter((f: any) => {
        const dateStr = f.properties.date_vol;
        if (!dateStr) return false;
        const featureDate = new Date(dateStr).getTime();
        return featureDate >= start && featureDate <= end;
      });
    }
    
    let allDatasToDisplay = filtered;
    let plotIds=this.getDistinctValues(allDatasToDisplay.map((x:any)=>x.properties.feature_id));
    let extent:any;
    const features = layerSource.getFeatures()
    if(features.length > 0){
      layerSource.forEachFeature((feature:any)=>{

        if(typeof feature.values_.condition_vol == 'object'){
          feature.set('condition_vol', '')
        }

        
        if(plotIds.indexOf(feature.get('feature_id'))>=0 || plotIds.indexOf(parseInt(feature.get('feature_id')))>=0){
          feature.set('display',"true");
        }
        else{
          feature.set('display',"false");
        }
      })
    }else{
      console.error('Pas de features')
    }
    this.computeChartDataByCondition(allDatasToDisplay);
    this.renderCharts();
  }


  filterDatas() {
    return this.datas.filter((feature: any) => {
      const props = feature.properties;
      const matchConditionVol = !this.selectedVolType || props.condition_vol === this.selectedVolType;

      const matchCompany = !this.selectedCompany || props.entreprise === this.selectedCompany;

      const matchRefMateriel = !this.selectedRefMateriel || props.ref_materiel === this.selectedRefMateriel;

      const matchMarque = !this.selectedMarque || props.marque === this.selectedMarque;

      const matchNumSerie = !this.selectedNumSerie || !this.selectedNumSerie.value || props.num_serie === this.selectedNumSerie.value;

      const matchDate = (!this.startDate || new Date(props.date_vol) >= new Date(this.startDate)) &&
                        (!this.endDate || new Date(props.date_vol) <= new Date(this.endDate));

      return matchConditionVol && matchCompany && matchRefMateriel && matchMarque && matchNumSerie && matchDate;
    });
  }
  
  renderCharts() {
    this.chartInstances.forEach(chart => chart.destroy());
    this.chartInstances = [];

    this.$nextTick(() => {
      this.filteredData.forEach((item, index) => {
        const graphDiv:any = this.$refs[`graphElement${index}`] as HTMLCanvasElement;
        if (graphDiv) {
          
          // graphDiv[0].height = this.selectedFeature ? 250 : item.title === 'Violence Vol' ? 120 : item.values.length <= 4 ? 120 : 200;
                    
          const chartInstance = new Chart(graphDiv, {
              type: 'bar',
              data: {
                labels: item.keys,
                datasets: [
                  {
                    label: item.label,
                    data: item.values,
                    backgroundColor: item.backgroundColor,
                    borderWidth: 1,
                  },
                ],
              },
              options: {
                responsive: true,
                legend:{
                  display: false,
                },
                plugins: {
                  datalabels: {
                    display: false,
                  },
                },
              },
            });
            this.chartInstances.push(chartInstance);
          }

        // }
      });
    });
  }
}
